const CHANGE_LOGGED_IN = 'CHANGE_LOGGED_IN';

const updateLoggedIn = (state = { isLoggedIn: false }, action) => {
    const { type = null, viewtype } = action;

    if (type === CHANGE_LOGGED_IN) {
        return viewtype;
    }

    return state;
};

export default updateLoggedIn;
